/* tslint:disable */
import DynamicRedirect from "@infrastructure/config/dynamicRedirect";
import { FeatureFlagType } from "@src/proxy/FeatureFlagType";
import VueRouter, { RouterOptions, Route } from "vue-router";
import * as FeatureFlagStore from "@app/shared/featureFlag/stores/featureFlagStore";
import Error from "@app/error/main.vue";

const Home: Function = () => import("@app/home/main.vue");
const Search: Function = () => import("@app/search/main.vue");
const Calendar: Function = () => import("@app/calendar/main.vue");
const Schedule: Function = () => import("@app/calendar/schedule.vue");
const ProviderAvailability: Function = () => import("@app/calendar/providerAvailability/providerAvailability.vue");
const Appointment: Function = () => import("@app/appointment/main.vue");
const NonAppointment: Function = () => import("@app/nonAppointment/main.vue");
const NonAppointmentService: Function = () => import("@app/nonAppointment/serviceMain.vue");
const Profile: Function = () => import("@app/profile/main.vue");
const PersonalDetails: Function = () => import("@app/profile/personalDetails/personalDetails.vue");
const ProfessionalDetails: Function = () => import("@app/profile/professionalDetails/professionalDetails.vue");
const KeyDocuments: Function = () => import("@app/profile/keyDocuments/keyDocuments.vue");
const Travel: Function = () => import("@app/travel/main.vue");
const ProviderVoucher: Function = () => import("@app/finance/voucher/providerVoucher.vue");
const ResourcePage: Function = () => import("@app/resourcePage/main.vue");
const ResourcePageDetails: Function = () => import("@app/resourcePage/detail.vue");
const Message: Function = () => import("@app/message/main.vue");
const Finance: Function = () => import("@app/finance/main.vue");
const Notification: Function = () => import("@app/message/notification/notification.vue");
const RemittanceAdvice: Function = () => import("@app/finance/remittanceAdvice/remittanceAdvice.vue");
const Conversation: Function = () => import("@app/message/conversation/conversation.vue");

export enum WellKnownRouter {
    Default = "default",
    Home = "home",
    Error = "error",
    Calendar = "calendar",
    Availability = "availability",
    Schedule = "schedule",
    NonAppointmentServices = "nonappointment services",
    InprogressNonAppointmentService = "inprogress-non-appointment-service",
    CompletedNonAppointmentService = "completed-non-appointment-service",
    Profile = "profile",
    PersonalDetails = "personal-details",
    ProfessionalDetails = "professional-details",
    KeyDocuments = "keyDocuments",
    Travel = "travel",
    ProviderVoucher = "provider-voucher",
    PaidVouchers = "paid-vouchers",
    ConsultingLocations = "consulting-locations",
    PublicInformation = "public-information",
    ProfessionalServices = "professional-services",
    ProviderAccreditations = "provider-accreditations",
    Appointment = "appointment",
    AppointmentDetails = "appointment-details",
    AppointmentAttachments = "appointment-attachments",
    AppointmentVouchers = "appointment-vouchers",
    AppointmentReport = "appointment-report",
    NonAppointment = "non-appointment",
    NonAppointmentDetails = "non-appointment-details",
    NonAppointmentAttachments = "non-appointment-attachments",
    NonAppointmentVouchers = "non-appointment-vouchers",
    NonAppointmentReport = "non-appointment-report",
    Search = "search",
    ResourcePages = "resource-pages",
    ResourcePageDetails = "resource-page-details",
    Message = "message",
    Finance = "finance",
    Redirect = "redirect",
    RemittanceAdvice = "remittance-advice",
    Notification = "notification",
    Conversation = "conversation",
    AppointmentClinicalNotes = "appointment-clinical-note",
    NonAppointmentClinicalNotes = "non-appointment-clinical-note",
    AppointmentEbmResource = "appointment-ebm-resource",
    NonAppointmentEbmResource = "non-appointment-ebm-resource",
}

export function createVueRouter(store) : VueRouter {
    let routerOptions = {
        linkExactActiveClass: "active",
        linkActiveClass: "active",
        routes: [
            { name: WellKnownRouter.Default, path: "*", redirect: "/home" },
            /*Home Page*/
            {
                name: WellKnownRouter.Home,
                path: "/home",
                component: Home,
                meta: { icon: "fa fa-home", description: "Home" },
                children: [
                    /*Error Page*/
                    {
                        name: WellKnownRouter.Error,
                        path: "error/:errorCode?",
                        component: Error,
                        meta: { icon: "fa fa-exclamation-triangle", description: "Error" },
                        props: (route) =>
                        ({
                            errorCode: route.params.errorCode as number
                        })
                    },
                    /*Calendar Page*/
                    {
                        name: WellKnownRouter.Calendar,
                        path: "calendar",
                        component: Calendar,
                        meta: { icon: "fa fa-calendar", description: "Calendar" },
                        redirect: "calendar/schedule",
                        children: [
                            {
                                name: WellKnownRouter.Schedule,
                                path: "schedule",
                                component: Schedule,
                                meta: { description: "Confirmed Schedule" },
                                props: (route) => ({ eventDate: route.params.eventDate as string })
                            },
                            {
                                name: WellKnownRouter.Availability,
                                path: "availability",
                                component: ProviderAvailability,
                                meta: { description: "Provide Availability" }
                            }
                        ]
                    },
                    /*Appointment Page*/
                    {
                        name: WellKnownRouter.Appointment,
                        path: "calendar/schedule/appointment/:appointmentId",
                        redirect: "calendar/schedule/appointment/:appointmentId/details",
                        component: Appointment,
                        meta: {
                            description: "Appointment",
                            breadcrumbs: [WellKnownRouter.Calendar, WellKnownRouter.Schedule]
                        },
                        props: (route) => {
                            return ({
                                appointmentId: parseInt(route.params.appointmentId, null)
                            });
                        },
                        children: [
                            {
                                name: WellKnownRouter.AppointmentDetails,
                                path: "details"
                            },
                            {
                                name: WellKnownRouter.AppointmentAttachments,
                                path: "attachments"
                            },
                            {
                                name: WellKnownRouter.AppointmentVouchers,
                                path: "vouchers"
                            },
                            {
                                name: WellKnownRouter.AppointmentReport,
                                path: "report"
                            },
                            {
                                name: WellKnownRouter.AppointmentClinicalNotes,
                                path: "clinicalNotes"
                            },
                            {
                                name: WellKnownRouter.AppointmentEbmResource,
                                path: "ebmResource"
                            }
                        ]
                    },
                    /*Non Appointment Service Page*/
                    {
                        name: WellKnownRouter.NonAppointmentServices,
                        path: "otherservices",
                        component: NonAppointmentService,
                        meta: { icon: "fa fa-calendar-minus-o", description: "Other Services" },
                        redirect: "otherservices/inprogress",
                        props: (route) => ({
                            typeId: route.params.typeid as string
                        }),
                        children: [
                            {
                                name: WellKnownRouter.InprogressNonAppointmentService,
                                path: "inprogress",
                                meta: { description: "Current Services" },
                                component: NonAppointmentService
                            },
                            {
                                name: WellKnownRouter.CompletedNonAppointmentService,
                                path: "completed",
                                meta: { description: "Past Services" },
                                component: NonAppointmentService
                            }
                        ]
                    },
                    /*Profile Page*/
                    {
                        name: WellKnownRouter.Profile,
                        component: Profile,
                        path: "profile",
                        meta: { description: "My Profile", icon: "fa fa-user photo" },
                        redirect: "profile/personalDetails",
                        children: [
                            {
                                name: WellKnownRouter.PersonalDetails,
                                path: "personalDetails",
                                meta: { description: "Personal Details" },
                                component: PersonalDetails
                            },
                            {
                                name: WellKnownRouter.ProfessionalDetails,
                                path: "professionalDetails",
                                redirect: "professionalDetails/consultingLocations",
                                meta: { description: "Professional Details" },
                                component: ProfessionalDetails,
                                children: [
                                    {
                                        name: WellKnownRouter.ConsultingLocations,
                                        path: "consultingLocations"
                                    },
                                    {
                                        name: WellKnownRouter.PublicInformation,
                                        path: "publicInformation"
                                    },
                                    {
                                        name: WellKnownRouter.ProfessionalServices,
                                        path: "professionalServices"
                                    },
                                    {
                                        name: WellKnownRouter.ProviderAccreditations,
                                        path: "providerAccreditations"
                                    }
                                ]
                            },
                            {
                                name: WellKnownRouter.KeyDocuments,
                                path: "keyDocuments",
                                meta: { description: "Key Documents" },
                                component: KeyDocuments
                            }
                        ]
                    },
                    /*NonAppointment Page*/
                    {
                        name: WellKnownRouter.NonAppointment,
                        path: "otherservices/otherservice/:nonAppointmentId",
                        redirect: "otherservices/otherservice/:nonAppointmentId/details",
                        component: NonAppointment,
                        meta: {
                            description: "Other Services",
                            breadcrumbs: [WellKnownRouter.NonAppointmentServices]
                        },
                        props: (route) => {
                            return ({
                                nonAppointmentId: parseInt(route.params.nonAppointmentId, null)
                            });
                        },
                        children: [
                            {
                                name: WellKnownRouter.NonAppointmentDetails,
                                path: "details"
                            },
                            {
                                name: WellKnownRouter.NonAppointmentAttachments,
                                path: "attachments"
                            },
                            {
                                name: WellKnownRouter.NonAppointmentVouchers,
                                path: "vouchers"
                            },
                            {
                                name: WellKnownRouter.NonAppointmentReport,
                                path: "report"
                            },
                            {
                                name: WellKnownRouter.NonAppointmentClinicalNotes,
                                path: "clinicalNotes"
                            },
                            {
                                name: WellKnownRouter.NonAppointmentEbmResource,
                                path: "ebmResource"
                            }
                        ]
                    },
                    /*Search page*/
                    {
                        name: WellKnownRouter.Search,
                        path: "search/:keyword?/:filter?",
                        component: Search,
                        meta: { description: "Search", icon: "fa fa-search" },
                        props: (route) =>
                        ({
                            keyword: route.params.keyword as string,
                            filter: route.params.filter as string
                        })
                    },
                    /*Resource Page*/
                    {
                        name: WellKnownRouter.ResourcePages,
                        path: "resourcePages/:tagid?",
                        meta: { description: "Resources", icon: "fa fa-book" },
                        component: ResourcePage,
                        props: (route) =>
                        ({
                            tagId: route.params.tagid as number
                        })
                    },
                    {
                        name: WellKnownRouter.ResourcePageDetails,
                        path: "resourcePage/:resourcePageId",
                        meta: {
                            description: "Resource Details",
                            icon: "fa fa-book",
                            breadcrumbs: [WellKnownRouter.ResourcePages]
                        },
                        component: ResourcePageDetails,
                        props: (route) => {
                            return ({
                                resourcePageId: route.params.resourcePageId as number
                            });
                        }
                    },
                    /*Messages page*/
                    {
                        name: WellKnownRouter.Message,
                        path: "messages",
                        meta: { icon: "fa fa-envelope", description: "Messages" },
                        component: Message,
                        redirect: "messages/message",
                        children: [
                            {
                                name: WellKnownRouter.Conversation,
                                path: "message/:topicId?",
                                component: Conversation,
                                meta: { description: "Messages" },
                                props: (route) => {
                                    return ({
                                        topicId: route.params.topicId as number
                                    });
                                },
                            },
                            {
                                name: WellKnownRouter.Notification,
                                path: "notification",
                                component: Notification,
                                meta: { description: "Notifications" }
                            }
                        ]
                    },
                    /*Finance page*/
                    {
                        name: WellKnownRouter.Finance,
                        path: "finance",
                        component: Finance,
                        meta: { icon: "fa fa-dollar", description: "Finance" },
                        redirect: "finance/vouchers",
                        children: [
                            {
                                name: WellKnownRouter.ProviderVoucher,
                                path: "vouchers",
                                meta: { description: "Vouchers" },
                                component: ProviderVoucher
                            },
                            {
                                name: WellKnownRouter.RemittanceAdvice,
                                path: "remittanceAdvice",
                                meta: { description: "Remittance Advice" },
                                component: RemittanceAdvice
                            }
                        ]
                    },
                    /*Travel Page*/
                    {
                        name: WellKnownRouter.Travel,
                        path: "travel",
                        meta: {
                            description: "Travel",
                            icon: "fa fa-plane",
                            conditionalRoute: true,
                            flagType: FeatureFlagType.Travel
                        },
                        component: Travel
                    }
                ]
            },

            /*Redirect to other pages*/
            {
                name: WellKnownRouter.Redirect,
                path: '/redirect/:actionType/:actionId?',
                redirect: to => DynamicRedirect.getRedirectRoute(to)
            }
        ]
    };
    let router = new VueRouter(routerOptions as RouterOptions);
    router.beforeEach(async (to, from, next) => {
        if (to.meta.conditionalRoute) {
            let enabled = await FeatureFlagStore.isFeatureFlagEnabled(store, to.meta.flagType);
            if (enabled) {
                next();
            } else {
                next({ name: WellKnownRouter.Home });
            }
        } else {
            next();
        }
    });

    return router as any;
};

export function isInPage($route: Route, page: WellKnownRouter): boolean {
    return $route.matched.filter(route => {
        return route.name === page;
    }).length > 0;
}

export function isInPages($route: Route, pages: WellKnownRouter[]): boolean {
    return $route.matched.filter(route => {
        return  pages.indexOf(route.name as WellKnownRouter) >= 0;
    }).length > 0;
}